import React from 'react';
import { VectorShiftQuery } from '@/components/peptides/VectorShiftQuery';

export default function PeptideAssistant() {
  return (
    <div className="container mx-auto py-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Peptide Knowledge Assistant</h1>
        <p className="text-muted-foreground mt-2">
          Access the latest research and clinical insights on peptides using natural language queries
        </p>
      </div>
      
      <VectorShiftQuery />
      
      <div className="mt-12 max-w-3xl mx-auto">
        <h2 className="text-xl font-semibold mb-4">How to use this tool</h2>
        <div className="grid gap-4 md:grid-cols-2">
          <div className="p-4 border rounded-lg">
            <h3 className="font-medium mb-2">Ask about mechanisms</h3>
            <p className="text-sm text-muted-foreground">
              "What is the mechanism of action of BPC-157 on tissue healing?"
            </p>
          </div>
          
          <div className="p-4 border rounded-lg">
            <h3 className="font-medium mb-2">Request protocols</h3>
            <p className="text-sm text-muted-foreground">
              "What's the optimal dosing protocol for LL-37 for gut health?"
            </p>
          </div>
          
          <div className="p-4 border rounded-lg">
            <h3 className="font-medium mb-2">Compare peptides</h3>
            <p className="text-sm text-muted-foreground">
              "Compare the effects of BPC-157 and TB-500 on musculoskeletal recovery"
            </p>
          </div>
          
          <div className="p-4 border rounded-lg">
            <h3 className="font-medium mb-2">Clinical applications</h3>
            <p className="text-sm text-muted-foreground">
              "How can peptides be incorporated into a longevity protocol?"
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}